module.exports = __webpack_public_path__ + "img/FedEx_Express.a8cc7b81.svg";